"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TABS = void 0;
var TABS = {
  BUTTON__INCLUDED_PRODUCTS: 'singleOrderTabs-button-includedProducts',
  BUTTON__EXCLUDED_PRODUCTS: 'singleOrderTabs-button-excludedProducts',
  BUTTON__NOTES: 'singleOrderTabs-button-notes',
  BUTTON__HISTORY: 'singleOrderTabs-button-history',
  BUTTON__INVOICE: 'singleOrderTabs-button-invoice',
  BUTTON__PLATFORMS: 'singleOrderTabs-button-linkedPlatforms',
  TEXT__DISPUTE_ALERT: 'singleOrderTabs-span-disputeAlert',
  TEXT__NOT_MATCHING_ALERT: 'singleOrderTabs-span-notMatchingAlert'
};
exports.TABS = TABS;